import React from "react";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import TitilMaintenance from "./TitilMaintenance"

const Maintenance = () => {
  return (
    <>
      <Header />
      <TitilMaintenance />
      <Footer />
    </>
  );
};
  

export default Maintenance;